<template>
  <div>
    <el-dialog
      :visible.sync="showDialog"
      :width="modalWidth"
      top="15vh"
      :modal-append-to-body="false"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <!-- The id in the next line maps the walkthrough to that div element. Please do not remove this id -->
      <div
        class="md:text-2xl text-center -mt-10 text-root-2 font-bold mb-3"
        id="fundAcctTourItem2"
      >
        Fund Account
      </div>
      <div>
        <div
          v-if="tenantPermission('multiple-currency-deposit-access')"
          class="mt-5 border-b w-full"
        >
          <div class="flex justify-between">
            <div
              class="text-center w-1/2 md:text-base pb-2 cursor-pointer transition duration-300 ease-in-linear"
              :class="
                isDepositView
                  ? 'border-b-2 text-primary font-bold border-primary'
                  : 'text-fg-muted font-normal'
              "
              @click="setActiveView('deposit')"
            >
              Deposit Funds
            </div>
            <el-tooltip
              content="You do not have multiple accounts to perform currency swaps"
              :disabled="filteredDepositAccounts.length > 1"
              position="top"
            >
              <div
                class="text-center w-1/2 md:text-base pb-2 cursor-pointer transition duration-300 ease-in-linear"
                :class="
                  isSwapView
                    ? 'border-b-2 text-primary font-bold border-primary'
                    : 'text-fg-muted font-normal'
                "
                v-on="
                  filteredDepositAccounts.length > 1
                    ? { click: () => setActiveView('swap') }
                    : {}
                "
              >
                Swap Funds
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="mt-3">
          <deposit-funds
            v-if="isDepositView"
            @showDepositDetails="showDepositDetails"
            @showAssetDeposit="showAssetDeposit"
            @addNewGBPAccount="addNewGBPAccount"
          />
          <swap-funds v-if="isSwapView" @showSwapDetails="showSwapDetails" />
        </div>
      </div>
    </el-dialog>
    <div class="fixed bottom-0 left-0 right-0 z-index bg-white">
      <initiate-tour-button @startTour="$emit('startTour')" />
    </div>
  </div>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import pendingDeposit from '@/mixins/pendingDeposit.js'
import tenant from '@/mixins/tenant.js'
import filteredDepositAccounts from '@/mixins/getBalance.js'
export default {
  mixins: [pendingDeposit, tenant, filteredDepositAccounts],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints,
      isLoading: false
    }
  },
  components: {
    InitiateTourButton: () =>
      import('@/components/v2/app-tour/InitiateTourButton.vue'),
    DepositFunds: () =>
      import(
        '@/components/v2/deposit/dialogs/fundAccountDialog/DepositFunds.vue'
      ),
    SwapFunds: () =>
      import('@/components/v2/deposit/dialogs/fundAccountDialog/SwapFunds.vue')
  },
  methods: {
    addNewGBPAccount () {
      this.$emit('addNewGBPAccount')
    },
    closeDialog () {
      this.handleClose()
    },
    showDepositDetails () {
      this.$emit('showDepositDetails')
    },
    showTransactionDetails () {
      this.$emit('showTransactionDetails')
    },
    showSwapDetails () {
      this.$emit('showSwapDetails')
    },
    showAssetDeposit () {
      this.$emit('showAssetDeposit')
    },
    setActiveView (view) {
      this.$store.dispatch('transactions/setFundAccountView', view)
    },
    handleClose () {
      this.$store.dispatch('transactions/setPendingDepositState', false)
      this.$emit('closeDialog')
    }
  },
  computed: {
    pendingDepositState () {
      return this.$store.state.transactions.pendingDepositState
    },
    isDepositView () {
      return this.activeView === this.$transactionType.DEPOSIT
    },
    isSwapView () {
      return this.activeView === this.$transactionType.SWAP
    },
    activeView () {
      return this.$store.state.transactions.fundAccountActiveView
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '27rem' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  mounted () {
    this.setActiveView(this.activeView)
  }
}
</script>

<style scoped>
.z-index {
  z-index: 8888888;
}
>>> .el-dialog {
  border-radius: 16px;
  padding: 5px;
  background-color: white;
}
>>> .el-dialog__close .el-icon .el-icon-close {
  color: black !important;
}
</style>
